module.exports = __webpack_public_path__ + "img/hgb.842401f3.png";